import React from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { createGlobalStyle } from 'styled-components';
import { Criticalities, getColorOrValue } from '../collectionPoolHelper';
import { v4 as uuidv4 } from 'uuid';

function CriticalitiesInfos() {
 
  return (
    <Container>
      <Styles />
      <ul className='module-list'>
        {Criticalities.map((criticality) => (
          <>
            <li>
              <Word value={`- ${criticality.title}`} variant='p' textStyle='normalBold' />
            </li>
            <ul>
              {criticality.colors.map((color) => {
                return Object.entries(color as object).map(
                  ([key, value]) => (
                    <li className='colors_list' key={uuidv4()}>
                      <div
                        className='circle'
                        style={{ backgroundColor: getColorOrValue(parseInt(key), 'css') as string }}
                      ></div>
                      {value}
                    </li>
                  ),
                );
              })}
            </ul>
          </>
        ))}
      </ul>
      <Container className='legend_container'>
        <Word value='Legende ' variant='h3' textStyle='normalBold' />
        <Word value='* Valeur des seuils ILI 	: cf paramétrage ILI dans le paramétrage du contrat ' />
        <Word className='italic_text' value='Valeurs par défaut : seuil peu sensible = 2 m³/j/km – Seuil très sensible = 4 m³/j/km' />
        <Word value='** Période sèche 	: cf paramétrage H2S dans le paramétrage du contrat' />
        <Word className='italic_text' value='Valeurs par défaut : Période sèche  = juin - septembre ' />
        <Word value='***Seuil HYDRO 		: cf paramétrage HYDRO dans le paramétrage du contrat' />
        <Word className='italic_text' value='Valeurs par défaut : nb Point noir critique = 1 ' />
      </Container>
    </Container>
  );
}

const Styles = createGlobalStyle`
.sds-reset-style{
    .module-list{
        ul{
            margin: 10px 50px;    
        }
        .colors_list{
            display: flex;
            align-items: center;
            flex-direction: row;
            .circle{
                border-radius: 100%;
                width: 10px;
                height: 10px;
                margin-right: 10px;
            }
        }
    }
    .legend_container{
        margin-left: 40px;
        margin-top: 10px;
        margin-bottom: 10px;
        .italic_text{
            color: gray;
            font-style: italic;
            font-size: 13px;
        }
    }
}`;
export default CriticalitiesInfos;
